import {
    ComponentFactoryResolver,
    ElementRef,
    Injector,
    StaticProvider,
    Type,
    ViewContainerRef,
} from '@angular/core';

import { BaseV1Component } from './component/v1/base/base-v1.component';
import { DataV1Component } from './component/v1/data/data-v1.component';
import { TextV1Component } from './component/v1/text/text-v1.component';
import { BaseV2Component } from './component/v2/base/base-v2.component';
import { TextV2Component } from './component/v2/text/text-v2.component';
import { applyStyles } from './function/apply-styles.function';
import {
    CMPS_EC_DATA_ELEMENT,
    CMPS_EC_SWITCH_CONTEXT,
    CMPS_EC_TEXT_ELEMENT,
} from './model/metadata';
import { SwitchContext } from './model/switch-context.model';

export function inflateBase(
    parentInjector: Injector,
    factoryResolver: ComponentFactoryResolver,
    viewContainerRef: ViewContainerRef,
    ctx: SwitchContext,
): void {
    viewContainerRef.clear();

    try {
        const providers: StaticProvider[] = [
            {
                provide: CMPS_EC_SWITCH_CONTEXT,
                useValue: ctx,
            },
        ];
        const compType = compForTpl(ctx.mapItem.tpl.version, 'base');
        const inj = Injector.create({
            providers,
            parent: parentInjector,
        });
        const comp = factoryResolver.resolveComponentFactory(compType);
        viewContainerRef.createComponent(comp, null, inj);
    } catch (err) {
        console.log(err);
    }
}

export function deflateBase(viewContainerRef: ViewContainerRef): void {
    viewContainerRef.clear();
}

export function inflateElements(
    parentInjector: Injector,
    factoryResolver: ComponentFactoryResolver,
    containerRef: ElementRef<HTMLElement>,
    viewContainerRef: ViewContainerRef,
    ctx: SwitchContext,
): void {
    if (
        ctx.mapItem.tpl.elementContainerStyles == null ||
        Object.keys(ctx.mapItem.tpl.elementContainerStyles).length === 0
    ) {
        containerRef.nativeElement.classList.add(
            'cmps-event-centre-c-pop-dialog--elements',
        );
    }

    applyStyles(
        containerRef.nativeElement,
        ctx.mapItem.tpl.elementContainerStyles,
    );

    viewContainerRef.clear();

    ctx.mapItem.tpl.elements.forEach((e) => {
        try {
            const providers: StaticProvider[] = [];
            switch (e.type.toLowerCase().trim()) {
                case 'text':
                    providers.push({
                        provide: CMPS_EC_TEXT_ELEMENT,
                        useValue: e,
                    });
                    break;
                case 'data':
                    providers.push({
                        provide: CMPS_EC_DATA_ELEMENT,
                        useValue: e,
                    });
                    break;
            }

            const compType = compForTpl(ctx.mapItem.tpl.version, e.type);
            const inj = Injector.create({
                providers,
                parent: parentInjector,
            });
            const comp = factoryResolver.resolveComponentFactory(compType);
            viewContainerRef.createComponent(comp, null, inj);
        } catch (err) {
            console.log(err);
        }
    });
}

export function deflateElements(viewContainerRef: ViewContainerRef): void {
    viewContainerRef.clear();
}

function compForTpl(version: string, type: string): Type<any> {
    if (version.trim().toLowerCase() === '1.0.0') {
        switch (type.toLowerCase().trim()) {
            case 'base':
                return BaseV1Component;
            case 'text':
                return TextV1Component;
            case 'data':
                return DataV1Component;
        }
    }
    if (version.trim().toLowerCase() === '2.0.0') {
        switch (type.toLowerCase().trim()) {
            case 'base':
                return BaseV2Component;
            case 'text':
                return TextV2Component;
            case 'data':
                return DataV1Component;
        }
    }
}
